import React from 'react';
import { FaChevronDown } from 'react-icons/fa';

interface BouncingArrowProps {
    location: string;
    size: number;
}

const BouncingArrow: React.FC<BouncingArrowProps> = ({ location, size }) => {
    const scrollToSection = () => document.querySelector(location)?.scrollIntoView({ behavior: 'smooth' });
    return (
        <div className='absolute text-center text-primary-text bottom-16 animate-bounce'>
            <button onClick={scrollToSection} className='cursor-pointer'>
                <FaChevronDown size={size} />
            </button>
        </div>
    );
};

export default BouncingArrow;